(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studios-page-best-sellers-feature"] && !Shopify.designMode) return;
  try {
                   
    $('').slick({      
        slidesToShow: 4, 
        slidesToScroll: 4,      
        dots: false,    
        arrows: false,   
        infinite: false,
        responsive: [
            {
                breakpoint: 9999,   
                settings: "unslick"
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,            
                    slidesToScroll: 1,       
                    dots: false,
                    arrows: false,       
                    adaptiveHeight: true                        
                }  
            }
        ]    
    });

  } catch(e) { console.error(e); }
})();
})();
